export default "__VITE_ASSET__DxJFkVjx__"